<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10.0002 12.5V14.1667M5.00016 17.5H15.0002C15.9206 17.5 16.6668 16.7538 16.6668 15.8333V10.8333C16.6668 9.91286 15.9206 9.16667 15.0002 9.16667H5.00016C4.07969 9.16667 3.3335 9.91286 3.3335 10.8333V15.8333C3.3335 16.7538 4.07969 17.5 5.00016 17.5ZM13.3335 9.16667V5.83333C13.3335 3.99238 11.8411 2.5 10.0002 2.5C8.15921 2.5 6.66683 3.99238 6.66683 5.83333V9.16667H13.3335Z"
      stroke="#134E4A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>
